<header id="header">
  <article class="header-content">
    <h1 class="logo">
      <a routerLink="/">
        <img class="mark" src="/assets/img/logo/logo.png" alt="日刊プロスポーツ新聞社" />
        <img class="txt" src="/assets/img/logo/nikkan-pro.png" alt="日刊プロスポーツ新聞社" />
      </a>
    </h1>
    <section class="nav" [ngClass]="{ active: snav$ | async }">
      <nikkan-corporate-nav />
    </section>
    <div class="snav-btn" [ngClass]="{ active: snav$ | async }" (click)="toggleSnav()">
      <ul class="lines">
        <li class="item"></li>
        <li class="item"></li>
        <li class="item"></li>
      </ul>
    </div>
  </article>
</header>
